import { ConnectorInfo } from '@blaze-shared/api-contracts-domain';
import { BaseSchema } from '@blaze-shared/schema-domain';
import { TransposeWorkflowNode } from '@blaze-shared/workflow-domain';

import { NODE_SOURCE_ID } from '../../errors/source-ids';
import { NodeNotLastWorkflowError, WorkflowError } from '../../errors/workflow-error';
import { getColumnReferencesFromString } from '../../references/get-references-from-string';
import {
  WorkflowNodeColumnReference,
  WorkflowNodeNamedInputReference,
  WorkflowNodeParamReference,
  WorkflowNodeTagReference,
} from '../../references/references.models';
import { BaseWorkflowNode, WorkflowNode } from '../../registry/node.registry';

@WorkflowNode('Transpose')
export class TransposeNode extends BaseWorkflowNode<TransposeWorkflowNode> {
  static readonly NODE_SOURCE_ID = NODE_SOURCE_ID;

  getColumnReferences(schemas: Map<string | symbol, BaseSchema>): WorkflowNodeColumnReference[] {
    return getColumnReferencesFromString(this.node.transposeColumn, schemas);
  }

  getTagReferences(_schemas: Map<string | symbol, BaseSchema>): WorkflowNodeTagReference[] {
    return [];
  }

  getParamReferences(
    _schemas: Map<string | symbol, BaseSchema>,
    _connectors: ConnectorInfo[],
  ): WorkflowNodeParamReference[] {
    return [];
  }

  getNamedInputReferences(
    _schemas: Map<string | symbol, BaseSchema>,
  ): WorkflowNodeNamedInputReference[] {
    return [];
  }

  override validate(
    schemas: Map<string | symbol, BaseSchema>,
    connectors: ConnectorInfo[],
  ): WorkflowError<any>[] {
    const errors = super.validate(schemas, connectors);

    if (this.node.nextNodeId) {
      errors.push(
        new NodeNotLastWorkflowError(
          this.workflowId,
          this.nodeId,
          'Transpose',
          TransposeNode.NODE_SOURCE_ID,
        ),
      );
    }

    return errors;
  }
}
